import { BroadcastService } from 'src/app/services/share/broadcast.service';
import { BookingPopoverPage } from './../../components/booking-popover/booking-popover.page';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { BookingService } from 'src/app/services/booking/booking.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';
import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import * as moment from 'moment';
import { AccountInformationService } from 'src/app/services/account-information/account-information.service';
import { IsUserLoggedInService } from 'src/app/services/user/is-user-logged-in.service';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.page.html',
  styleUrls: ['./bookings.page.scss'],
})
export class BookingsPage implements OnInit {
  moment: any = moment;
  subscription = new SubSink();
  bookings: any = [];
  originalBookings: any = [];
  s3_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '../../../assets/images/profile-placeholder.png';
  roles: any;
  showSpinner: boolean = false;

  selectedAccountType = 'all';

  loggedin_account_type: string = null;
  loggedin_user_id: string = null;

  isListView: boolean = true;
  isMapView: boolean = false;

  @ViewChild(MapInfoWindow) infoWindowsView: MapInfoWindow;

  info_content: string = '';
  display: any;
  center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  zoom = 4;
  artistsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/artists-marker.png',
  };
  bandsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/bands-marker.png',
  };
  venuesmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/venues-marker.png',
  };
  usermarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/user-marker.png',
  };
  comediansmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/comedians-marker.png',
  };
  comedyclubsmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/comedyclub-marker.png',
  };
  foodtrucksmarkerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '../../../assets/icons/foodtruck-marker.png',
  };
  mapMarkerPositions: google.maps.LatLngLiteral[] = [];
  markerPositions: any = [];
  subscribed: boolean = false;

  constructor(
    public popover: PopoverController,
    private bookingService: BookingService,
    private accountInfoService: AccountInformationService,
    public router: Router,
    private registerService: RegisterResetpassService,
    private broadcastService : BroadcastService,
    private loggedInService: IsUserLoggedInService
  ) {
    Window['myComponent'] = this;

  }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.loggedInService._subscribeStatus.subscribe((value) => {
      this.subscribed = value;
    });

    if (this.isUserLoggedIn()) {
      this.loggedin_account_type = this.accountInfoService.getUserProfile().account_type;
      this.loggedin_user_id = this.accountInfoService.getUserProfile().id;
    }

    let data = {
      category: this.selectedAccountType
    }

    this.broadcastService.coordinate$.subscribe((res:any)=>{
      this.bookingService.latitude(res.coordinate.latitude);
      this.bookingService.longitude(res.coordinate.longitude);
      this.getAccountTypesBooking(data);
    });

    this.getAccountTypesBooking(data);
  }

  ionViewDidEnter(){
    this.getUserAccountTypes();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  getAccountTypesBooking(data) {
    this.showSpinner = true;
    this.subscription.sink = this.bookingService.getAccountTypesBooking(data).subscribe(
      (res: any) => {
        // console.log("bookings listing --> ",res.data);
        this.bookings = res.data;
        this.originalBookings = Object.assign(res.data);
        // console.log("Bookings ==> ",this.bookings);
        this.bookings.forEach(item => {
          // console.log("Booked bookings ==> ",item.booked_bookings);
          item.isLoggedinBooked = false;
          item.loggedinBookedStatus = '';
          item.booked_bookings.forEach(element => {
            // console.log("b booking customer id =>",element.customer_id);
            if (element.customer_id === this.loggedin_user_id) {
              item.isLoggedinBooked = true;
              item.loggedinBookedStatus = element.status;
              // console.log("logged in booking");
            }
          });
        });

        // console.log("Bookings ==> ",this.bookings);

        this.showBookingsGoogleMap(this.bookings);
      },
      (error) => console.log(error)
    );
  }

  async showBookingPopover(booking) {
    if (this.isUserLoggedIn()) {
      let booking_id = booking.id
      const pop = await this.popover.create({
        component: BookingPopoverPage,
        componentProps: {booking_id: booking_id},
        cssClass: 'booking-popover'
      });
      pop.present();
      const {data} = await pop.onDidDismiss();
      if (data !== undefined) {
        let data = {
          category: this.selectedAccountType
        }
        this.getAccountTypesBooking(data);
      }
    } else {
      this.router.navigate(['login']);
    }

  }

  goToProfile(account_type, user_id) {
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';

    this.router.navigate([type + '/' + btoa(user_id)]);
  }

  showMapView() {
    let data = {
      category: this.selectedAccountType
    }
    this.getAccountTypesBooking(data);
    this.isListView = false;
    this.isMapView = true;
  }

  showListView() {
    let data = {
      category: this.selectedAccountType
    }
    this.getAccountTypesBooking(data);
    this.isMapView = false;
    this.isListView = true;
  }

  getUserAccountTypes() {
    this.subscription.sink = this.registerService.getAccountTypes().subscribe(
      (roles: any[]) => {
        this.roles = roles['data'];
      },
      (error) => console.log(error)
    );
  }

  filterBookings(evt) {
    this.selectedAccountType = evt.srcElement.value;
    let data = {
      category: this.selectedAccountType
    }
    this.getAccountTypesBooking(data);
  }

  public openInfoWindow(marker: MapMarker, msg: string) {
    this.info_content = msg;
    this.infoWindowsView.open(marker);
  }

  showBookingsGoogleMap(bookings) {
    // console.log('map bookings --> ', bookings);
    this.markerPositions = [];
    this.showSpinner = false;
    bookings.forEach((booking) => {
      let options = null;
      if (booking?.user?.account_type?.id == 1) {
        options = this.bandsmarkerOptions;
      } else if (booking?.user?.account_type?.id == 2) {
        options = this.comediansmarkerOptions;
      } else if (booking?.user?.account_type?.id == 3) {
        options = this.foodtrucksmarkerOptions;
      } else if (booking?.user?.account_type?.id == 4) {
        options = this.usermarkerOptions;
      } else if (booking?.user?.account_type?.id == 5) {
        options = this.venuesmarkerOptions;
      } else if (booking?.user?.account_type?.id == 6) {
        options = this.comedyclubsmarkerOptions;
      } else if (booking?.user?.account_type?.id == 7) {
        options = this.artistsmarkerOptions;
      }
      let profile_pic: string = booking.user.user_account_information
        ?.profile_image
        ? this.s3_url + booking.user.user_account_information?.profile_image
        : this.profilePlaceholder;
      let bookingDate: string = '';
      bookingDate = moment(booking.start_date).format('MMMM D, YYYY');
      let avgBookingPayout: string = '';
      if (booking.average_booking_pay_out !== '') {
        avgBookingPayout = booking.average_booking_pay_out;
      } else {
        avgBookingPayout = 'N/A';
      }

      this.markerPositions.push({
        options: options,
        message:
          `<div class="bg-grunge p-3 flex map_window">
          <img class=" max-w-sm pr-4" src="`+profile_pic+`">
          <div class="text-center flex-1">
            <h1 class="uppercase">`+booking?.user?.first_name +' '+booking?.user?.last_name+`</h1>
            <a onclick="Window.myComponent.goToProfile('`+booking?.user?.account_type?.id+`', '`+booking?.user_id+`')" class="uppercase cursor-pointer">[View profile]</a>
          </div>
        </div>
        <div class="-mt-2 mx-2 bg-cll-danger map_info_event uppercase text-white">
        <p class="mb-2">
              <span class="text-white font-bold">Date: </span>
                ` +
              bookingDate +
              `
              </p>
          <p class="mb-2">
            <span class="text-white font-bold">Average Booking Payout: </span>
            `+avgBookingPayout+`
          </p>
          <p class="mb-5">
            <span class="text-white font-bold">Who: </span>
            `+booking?.user?.first_name +' '+booking?.user?.last_name+`
          </p>
          <p class="mb-2">
            <span class="text-white flex justify-between">
              <span>
                <span class="font-bold">Address: </span>
              </span>
              <span class="font-bold ml-2">`+booking.map_distance+` Miles away</span>
              <p class="mb-5 address_link">
                <a target="_blank" href="https://maps.google.com/?q=`+booking.lat+`,`+booking.long+`">`+booking.booking_address+`</a>
                <span>
                  <ion-icon class="cursor-pointer" onclick="Window.myComponent.copyToClipboard('`+this.addSlashes(booking.booking_address)+`')" name="copy-outline"></ion-icon>
                  <span id="custom-tooltip" class="capitalize text-black bg-white font-bold" style="padding: 2px 7px;  border-radius: 4px; display: none;">copied</span>
                </span>
              </p>
            </span>
          </p>
        </div>`,
      });
      this.mapMarkerPositions.push({
        lat: Number(booking.lat),
        lng: Number(booking.long),
      });
      this.display = {
        lat: Number(booking.lat),
        lng: Number(booking.long),
      };
      this.center = {
        lat: Number(booking.lat),
        lng: Number(booking.long),
      };
    });
  }

  addSlashes(string) {
    if(string)
      return string.replace(/\\/g, '\\\\').
          replace(/\u0008/g, '\\b').
          replace(/\t/g, '\\t').
          replace(/\n/g, '\\n').
          replace(/\f/g, '\\f').
          replace(/\r/g, '\\r').
          replace(/'/g, '\\\'').
          replace(/"/g, '\\"');
    else
      return '';
  }

  copyToClipboard = str => {
    if(!navigator.clipboard){
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      document.getElementById("custom-tooltip").style.display = "inline";
      setTimeout( function() {
        document.getElementById("custom-tooltip").style.display = "none";
      }, 1000);
    }else{
      navigator.clipboard.writeText(str).then(function() {
        document.getElementById("custom-tooltip").style.display = "inline";
        setTimeout( function() {
          document.getElementById("custom-tooltip").style.display = "none";
        }, 1000);
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }


  searchBookings(event:any) {
    var value = event.target.value.trim().toLowerCase();
    this.bookings = Object.assign(this.originalBookings.filter((data)=>{
      return (data.user.first_name + ' ' + data.user.last_name).trim().toLowerCase().includes(value)
        || data.category.trim().toLowerCase().includes(value)
        || (data.user.user_contact_information !== null ? (data.user.user_contact_information.us_city.city + ',' + data.user.user_contact_information.us_state.state_code).trim().toLowerCase().includes(value) : "N/A".trim().toLowerCase().includes(value))
        || data.distance.trim().toLowerCase().includes(value)
        || (data.price_range_from + ' to ' + data.price_range_to).trim().toLowerCase().includes(value)
        || (data.average_booking_pay_out !== null ? data.average_booking_pay_out.trim().toLowerCase().includes(value) : "N/A".trim().toLowerCase().includes(value))
        || (data.booked_bookings.length > 0 && data.booked_bookings[0].status.trim().toLowerCase().includes(value));
    }));
  }


  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

}
